'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var WantManager = require('./want-manager');

var Network = require('./network');

var DecisionEngine = require('./decision-engine');

var Notifications = require('./notifications');

var logger = require('./utils').logger;

var Stats = require('./stats');

var defaultOptions = {
  statsEnabled: false,
  statsComputeThrottleTimeout: 1000,
  statsComputeThrottleMaxQueueSize: 1000
};
var statsKeys = ['blocksReceived', 'dataReceived', 'dupBlksReceived', 'dupDataReceived', 'blocksSent', 'dataSent', 'providesBufferLength', 'wantListLength', 'peerCount'];
/**
 * JavaScript implementation of the Bitswap 'data exchange' protocol
 * used by IPFS.
 *
 * @param {Libp2p} libp2p
 * @param {Blockstore} blockstore
 * @param {Object} options
 */

var Bitswap = /*#__PURE__*/function () {
  function Bitswap(libp2p, blockstore, options) {
    _classCallCheck(this, Bitswap);

    this._libp2p = libp2p;
    this._log = logger(this.peerInfo.id);
    this._options = Object.assign({}, defaultOptions, options); // stats

    this._stats = new Stats(statsKeys, {
      enabled: this._options.statsEnabled,
      computeThrottleTimeout: this._options.statsComputeThrottleTimeout,
      computeThrottleMaxQueueSize: this._options.statsComputeThrottleMaxQueueSize
    }); // the network delivers messages

    this.network = new Network(libp2p, this, {}, this._stats); // local database

    this.blockstore = blockstore;
    this.engine = new DecisionEngine(this.peerInfo.id, blockstore, this.network, this._stats); // handle message sending

    this.wm = new WantManager(this.peerInfo.id, this.network, this._stats);
    this.notifications = new Notifications(this.peerInfo.id);
  }

  _createClass(Bitswap, [{
    key: "_receiveMessage",
    // handle messages received through the network
    value: function () {
      var _receiveMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerId, incoming) {
        var _this2 = this;

        var blocks, wanted;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.engine.messageReceived(peerId, incoming);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                // Only logging the issue to process as much as possible
                // of the message. Currently `messageReceived` does not
                // throw any errors, but this could change in the future.
                this._log('failed to receive message', incoming);

              case 8:
                if (!(incoming.blocks.size === 0)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                blocks = Array.from(incoming.blocks.values()); // quickly send out cancels, reduces chances of duplicate block receives

                wanted = blocks.filter(function (b) {
                  return _this2.wm.wantlist.contains(b.cid);
                }).map(function (b) {
                  return b.cid;
                });
                this.wm.cancelWants(wanted);
                _context2.next = 15;
                return Promise.all(blocks.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(b) {
                    var wasWanted;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            wasWanted = wanted.includes(b.cid);
                            _context.next = 3;
                            return _this2._handleReceivedBlock(peerId, b, wasWanted);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function _receiveMessage(_x, _x2) {
        return _receiveMessage2.apply(this, arguments);
      }

      return _receiveMessage;
    }()
  }, {
    key: "_handleReceivedBlock",
    value: function () {
      var _handleReceivedBlock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peerId, block, wasWanted) {
        var has;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._log('received block');

                _context3.next = 3;
                return this.blockstore.has(block.cid);

              case 3:
                has = _context3.sent;

                this._updateReceiveCounters(peerId.toB58String(), block, has);

                if (!(has || !wasWanted)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return");

              case 7:
                _context3.next = 9;
                return this.put(block);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _handleReceivedBlock(_x4, _x5, _x6) {
        return _handleReceivedBlock2.apply(this, arguments);
      }

      return _handleReceivedBlock;
    }()
  }, {
    key: "_updateReceiveCounters",
    value: function _updateReceiveCounters(peerId, block, exists) {
      this._stats.push(peerId, 'blocksReceived', 1);

      this._stats.push(peerId, 'dataReceived', block.data.length);

      if (exists) {
        this._stats.push(peerId, 'dupBlksReceived', 1);

        this._stats.push(peerId, 'dupDataReceived', block.data.length);
      }
    } // handle errors on the receiving channel

  }, {
    key: "_receiveError",
    value: function _receiveError(err) {
      this._log.error('ReceiveError: %s', err.message);
    } // handle new peers

  }, {
    key: "_onPeerConnected",
    value: function _onPeerConnected(peerId) {
      this.wm.connected(peerId);
    } // handle peers being disconnected

  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(peerId) {
      this.wm.disconnected(peerId);
      this.engine.peerDisconnected(peerId);

      this._stats.disconnected(peerId);
    }
    /**
     * @returns {void}
     */

  }, {
    key: "enableStats",
    value: function enableStats() {
      this._stats.enable();
    }
    /**
     * @returns {void}
     */

  }, {
    key: "disableStats",
    value: function disableStats() {
      this._stats.disable();
    }
    /**
     * Return the current wantlist for a given `peerId`
     *
     * @param {PeerId} peerId
     * @returns {Map}
     */

  }, {
    key: "wantlistForPeer",
    value: function wantlistForPeer(peerId) {
      return this.engine.wantlistForPeer(peerId);
    }
    /**
     * Return ledger information for a given `peerId`
     *
     * @param {PeerId} peerId
     * @returns {Object}
     */

  }, {
    key: "ledgerForPeer",
    value: function ledgerForPeer(peerId) {
      return this.engine.ledgerForPeer(peerId);
    }
    /**
     * Fetch a given block by cid. If the block is in the local
     * blockstore it is returned, otherwise the block is added to the wantlist and returned once another node sends it to us.
     *
     * @param {CID} cid
     * @returns {Promise<Block>}
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, block;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context4.prev = 2;
                _iterator = _asyncIterator(this.getMany([cid]));

              case 4:
                _context4.next = 6;
                return _iterator.next();

              case 6:
                _step = _context4.sent;
                _iteratorNormalCompletion = _step.done;
                _context4.next = 10;
                return _step.value;

              case 10:
                _value = _context4.sent;

                if (_iteratorNormalCompletion) {
                  _context4.next = 17;
                  break;
                }

                block = _value;
                return _context4.abrupt("return", block);

              case 14:
                _iteratorNormalCompletion = true;
                _context4.next = 4;
                break;

              case 17:
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 23:
                _context4.prev = 23;
                _context4.prev = 24;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 28;
                return _iterator.return();

              case 28:
                _context4.prev = 28;

                if (!_didIteratorError) {
                  _context4.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context4.finish(28);

              case 32:
                return _context4.finish(23);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 19, 23, 33], [24,, 28, 32]]);
      }));

      function get(_x7) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Fetch a a list of blocks by cid. If the blocks are in the local
     * blockstore they are returned, otherwise the blocks are added to the wantlist and returned once another node sends them to us.
     *
     * @param {Iterable<CID>} cids
     * @returns {Promise<AsyncIterator<Block>>}
     */

  }, {
    key: "getMany",
    value: function getMany(cids) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var pendingStart, wantList, promptedNetwork, fetchFromNetwork, _iterator3, _step3, cid, has;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                pendingStart = cids.length;
                wantList = [];
                promptedNetwork = false;

                fetchFromNetwork = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid) {
                    var blockP, block;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            wantList.push(cid);
                            blockP = _this.notifications.wantBlock(cid);

                            if (!pendingStart) {
                              _this.wm.wantBlocks(wantList);
                            }

                            _context5.next = 5;
                            return blockP;

                          case 5:
                            block = _context5.sent;

                            _this.wm.cancelWants([cid]);

                            return _context5.abrupt("return", block);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function fetchFromNetwork(_x8) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                _iterator3 = _createForOfIteratorHelper(cids);
                _context6.prev = 5;

                _iterator3.s();

              case 7:
                if ((_step3 = _iterator3.n()).done) {
                  _context6.next = 23;
                  break;
                }

                cid = _step3.value;
                _context6.next = 11;
                return _awaitAsyncGenerator(_this.blockstore.has(cid));

              case 11:
                has = _context6.sent;
                pendingStart--;

                if (!has) {
                  _context6.next = 18;
                  break;
                }

                if (!pendingStart) {
                  _this.wm.wantBlocks(wantList);
                }

                _context6.next = 17;
                return _this.blockstore.get(cid);

              case 17:
                return _context6.abrupt("continue", 21);

              case 18:
                if (!promptedNetwork) {
                  promptedNetwork = true;

                  _this.network.findAndConnect(cids[0]).catch(function (err) {
                    return _this._log.error(err);
                  });
                } // we don't have the block locally so fetch it from the network


                _context6.next = 21;
                return fetchFromNetwork(cid);

              case 21:
                _context6.next = 7;
                break;

              case 23:
                _context6.next = 28;
                break;

              case 25:
                _context6.prev = 25;
                _context6.t0 = _context6["catch"](5);

                _iterator3.e(_context6.t0);

              case 28:
                _context6.prev = 28;

                _iterator3.f();

                return _context6.finish(28);

              case 31:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[5, 25, 28, 31]]);
      }))();
    }
    /**
     * Removes the given CIDs from the wantlist independent of any ref counts
     *
     * @param {Iterable<CID>} cids
     * @returns {void}
     */

  }, {
    key: "unwant",
    value: function unwant(cids) {
      var _this3 = this;

      if (!Array.isArray(cids)) {
        cids = [cids];
      }

      this.wm.unwantBlocks(cids);
      cids.forEach(function (cid) {
        return _this3.notifications.unwantBlock(cid);
      });
    }
    /**
     * Removes the given keys from the want list
     *
     * @param {Iterable<CID>} cids
     * @returns {void}
     */

  }, {
    key: "cancelWants",
    value: function cancelWants(cids) {
      if (!Array.isArray(cids)) {
        cids = [cids];
      }

      this.wm.cancelWants(cids);
    }
    /**
     * Put the given block to the underlying blockstore and
     * send it to nodes that have it in their wantlist.
     *
     * @param {Block} block
     * @returns {Promise<void>}
     */

  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(block) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.putMany([block]));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function put(_x9) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Put the given blocks to the underlying blockstore and
     * send it to nodes that have it them their wantlist.
     *
     * @param {AsyncIterable<Block>|Iterable<Block>} blocks
     * @returns {Promise<void>}
     */

  }, {
    key: "putMany",
    value: function () {
      var _putMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(blocks) {
        var self;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // eslint-disable-line require-await
                self = this;
                return _context9.abrupt("return", this.blockstore.putMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                  var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, block;

                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _context8.prev = 2;
                          _iterator2 = _asyncIterator(blocks);

                        case 4:
                          _context8.next = 6;
                          return _awaitAsyncGenerator(_iterator2.next());

                        case 6:
                          _step2 = _context8.sent;
                          _iteratorNormalCompletion2 = _step2.done;
                          _context8.next = 10;
                          return _awaitAsyncGenerator(_step2.value);

                        case 10:
                          _value2 = _context8.sent;

                          if (_iteratorNormalCompletion2) {
                            _context8.next = 25;
                            break;
                          }

                          block = _value2;
                          _context8.next = 15;
                          return _awaitAsyncGenerator(self.blockstore.has(block.cid));

                        case 15:
                          if (!_context8.sent) {
                            _context8.next = 17;
                            break;
                          }

                          return _context8.abrupt("continue", 22);

                        case 17:
                          _context8.next = 19;
                          return block;

                        case 19:
                          self.notifications.hasBlock(block);
                          self.engine.receivedBlocks([block.cid]); // Note: Don't wait for provide to finish before returning

                          self.network.provide(block.cid).catch(function (err) {
                            self._log.error('Failed to provide: %s', err.message);
                          });

                        case 22:
                          _iteratorNormalCompletion2 = true;
                          _context8.next = 4;
                          break;

                        case 25:
                          _context8.next = 31;
                          break;

                        case 27:
                          _context8.prev = 27;
                          _context8.t0 = _context8["catch"](2);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context8.t0;

                        case 31:
                          _context8.prev = 31;
                          _context8.prev = 32;

                          if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                            _context8.next = 36;
                            break;
                          }

                          _context8.next = 36;
                          return _awaitAsyncGenerator(_iterator2.return());

                        case 36:
                          _context8.prev = 36;

                          if (!_didIteratorError2) {
                            _context8.next = 39;
                            break;
                          }

                          throw _iteratorError2;

                        case 39:
                          return _context8.finish(36);

                        case 40:
                          return _context8.finish(31);

                        case 41:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8, null, [[2, 27, 31, 41], [32,, 36, 40]]);
                }))()));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function putMany(_x10) {
        return _putMany.apply(this, arguments);
      }

      return putMany;
    }()
    /**
     * Get the current list of wants.
     *
     * @returns {Iterator<WantlistEntry>}
     */

  }, {
    key: "getWantlist",
    value: function getWantlist() {
      return this.wm.wantlist.entries();
    }
    /**
     * Get the current list of partners.
     *
     * @returns {Iterator<PeerId>}
     */

  }, {
    key: "peers",
    value: function peers() {
      return this.engine.peers();
    }
    /**
     * Get stats about the bitswap node.
     *
     * @returns {Object}
     */

  }, {
    key: "stat",
    value: function stat() {
      return this._stats;
    }
    /**
     * Start the bitswap node.
     *
     * @returns {void}
     */

  }, {
    key: "start",
    value: function start() {
      this.wm.start();
      this.network.start();
      this.engine.start();
    }
    /**
     * Stop the bitswap node.
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      this._stats.stop();

      this.wm.stop();
      this.network.stop();
      this.engine.stop();
    }
  }, {
    key: "peerInfo",
    get: function get() {
      return this._libp2p.peerInfo;
    }
  }]);

  return Bitswap;
}();

module.exports = Bitswap;